(function () {
  function resetSlideVideo(slide) {
    var toggle = slide.querySelector('[data-ik-hero-toggle]');
    var label = slide.querySelector('[data-ik-hero-toggle-label]');
    var poster = slide.querySelector('[data-ik-hero-poster]');
    var videoPanel = slide.querySelector('[data-ik-hero-video]');
    var video = videoPanel ? videoPanel.querySelector('video') : null;

    if (!toggle || !label || !poster || !videoPanel || !video) return;

    video.pause();
    video.currentTime = 0;
    videoPanel.hidden = true;
    poster.hidden = false;
    toggle.setAttribute('aria-expanded', 'false');
    label.textContent = toggle.dataset.playLabel;
    slide.classList.remove('is-video-active');
  }

  function initializeSlideVideo(slide) {
    var toggle = slide.querySelector('[data-ik-hero-toggle]');
    var label = slide.querySelector('[data-ik-hero-toggle-label]');
    var poster = slide.querySelector('[data-ik-hero-poster]');
    var videoPanel = slide.querySelector('[data-ik-hero-video]');
    var video = videoPanel ? videoPanel.querySelector('video') : null;

    if (!toggle || !label || !poster || !videoPanel || !video || toggle.dataset.ikVideoReady === 'true') return;

    toggle.addEventListener('click', function () {
      if (videoPanel.hidden) {
        poster.hidden = true;
        videoPanel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        label.textContent = toggle.dataset.posterLabel;
        slide.classList.add('is-video-active');

        var playRequest = video.play();
        if (playRequest && typeof playRequest.catch === 'function') {
          playRequest.catch(function () {
            video.controls = true;
          });
        }
      } else {
        resetSlideVideo(slide);
      }
    });

    toggle.dataset.ikVideoReady = 'true';
  }

  function initializeHeroSliders(root) {
    var sliders = root.querySelectorAll ? root.querySelectorAll('[data-ik-hero-slider]') : [];

    sliders.forEach(function (slider) {
      if (slider.dataset.ikSliderReady === 'true') return;

      var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-ik-hero-slide]'));
      var status = slider.querySelector('[data-ik-slider-status]');
      var currentIndex = 0;
      var touchStartX = null;
      var touchStartY = null;

      if (!slides.length) return;

      slides.forEach(initializeSlideVideo);

      function showSlide(nextIndex, announce) {
        var normalizedIndex = (nextIndex + slides.length) % slides.length;

        slides.forEach(function (slide, index) {
          var isActive = index === normalizedIndex;

          if (!isActive) resetSlideVideo(slide);
          slide.hidden = !isActive;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        slider.querySelectorAll('[data-ik-slider-go]').forEach(function (dot) {
          var isCurrent = Number(dot.dataset.ikSliderGo) === normalizedIndex;
          if (isCurrent) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });

        currentIndex = normalizedIndex;

        if (announce && status) {
          var heading = slides[currentIndex].querySelector('.ik-hero__title');
          status.textContent = 'Showing ' + (heading ? heading.textContent.trim() : 'featured product') + ', slide ' + (currentIndex + 1) + ' of ' + slides.length + '.';
        }
      }

      slider.addEventListener('click', function (event) {
        var directionButton = event.target.closest('[data-ik-slider-direction]');
        var dotButton = event.target.closest('[data-ik-slider-go]');

        if (directionButton) {
          showSlide(currentIndex + (directionButton.dataset.ikSliderDirection === 'next' ? 1 : -1), true);
        } else if (dotButton) {
          showSlide(Number(dotButton.dataset.ikSliderGo), true);
        }
      });

      slider.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (event.target.matches('input, textarea, select, video')) return;

        event.preventDefault();
        showSlide(currentIndex + (event.key === 'ArrowRight' ? 1 : -1), true);
      });

      slider.addEventListener('touchstart', function (event) {
        if (event.target.closest('a, button, video')) return;
        touchStartX = event.changedTouches[0].clientX;
        touchStartY = event.changedTouches[0].clientY;
      }, { passive: true });

      slider.addEventListener('touchend', function (event) {
        if (touchStartX === null || touchStartY === null) return;

        var deltaX = event.changedTouches[0].clientX - touchStartX;
        var deltaY = event.changedTouches[0].clientY - touchStartY;
        touchStartX = null;
        touchStartY = null;

        if (Math.abs(deltaX) < 48 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        showSlide(currentIndex + (deltaX < 0 ? 1 : -1), true);
      }, { passive: true });

      showSlide(0, false);
      slider.dataset.ikSliderReady = 'true';
    });
  }

  function start() {
    initializeHeroSliders(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeHeroSliders(event.target);
  });
})();
